<ng-template #addEditManualunschedulerEvent let-modalProduct>
  <div class="modal-header">
     <h4 class="modal-title" id="modal-basic-title">{{ 'Admin.manual_unscheduled_event' | translate }}</h4>
     <button type="button" class="modal_close close" aria-label="Close" (click)="closeModal(modalProduct)">
     <span aria-hidden="true"><em class="fa fa-times"></em></span>
     </button>
  </div>
  <div class="modal-body">
     <div class="row">
        <div class="col-md-6">
           <div class="form-group">
              <label class="label_grey">{{ 'Admin.plant_name' | translate }}<span class="mandatory">*</span></label>
              <input type="text" name="plant_name" id="plant_name" class="form-control" [(ngModel)]="selectedPlantName" disabled>
           </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                <label class="label_grey">{{ 'Admin.line_name' | translate }}<span class="mandatory">*</span></label>
                <input type="text" name="line_name" id="line_name" class="form-control" [(ngModel)]="selectedLineName" disabled>
            </div>
        </div>
     </div>
     <div class="row pt-2">
        <div class="col-md-12">
            <div class="form-group">
                <label class="label_grey">{{ 'Admin.unscheduled_event_title' | translate }}</label>
                <input type="text" name="title" id="title" class="form-control" placeholder="{{ 'Admin.unscheduled_event_title' | translate }}" [(ngModel)]="manualUnschedulerEvent.Title" (input)="checkSubmitEnabled()" [disabled]="isAllFieldsLocked || isEventStarted">
            </div>
        </div>
     </div>
     <div class="row pt-2">
        <div class="col-md-12">
            <div class="form-group row py-2 justify-content-center">
                <label class="col-4 p-0 label_grey">{{ 'Admin.enable_shift_time' | translate }}</label>
                <label class="col-3 p-0 switch">
                    <input type="checkbox" name="shift_time_toggle" id="shift_time_toggle" [(ngModel)]="useShiftTimeFlag" (change)="onShiftTimeToggle(); checkSubmitEnabled()" [disabled]="isAllFieldsLocked || isEventStarted">
                    <span class="slider round"></span>
                </label>
            </div>
        </div>
     </div>
     <div *ngIf="useShiftTimeFlag" class="row pt-2">
        <div class="col-md-12">
            <label class="label_grey">{{ 'Admin.event_date' | translate }}<span class="mandatory">*</span></label>
            <div class="input-group">
                <input class="form-control" type="text" name="event_date" id="event_date" placeholder="mm/dd/yyyy" [(ngModel)]="selectedEventDate"
                    (dateSelect)="onShiftDateSelect(); checkSubmitEnabled();"
                    ngbDatepicker #eventDate="ngbDatepicker" [minDate]="miniumNgbStartDate"
                    autocomplete="off" [readonly]="isAllFieldsLocked || isEventStarted">
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary calendar select-date" type="button" (click)="eventDate.toggle();" [disabled]="isAllFieldsLocked || isEventStarted"><i class="fa fa-calendar"></i></button>
                </div>
            </div>
        </div>
     </div>
     <div *ngIf="!useShiftTimeFlag" class="row  pt-2">
        <div class="col-md-6">
            <label class="label_grey">{{ 'Admin.event_start_date' | translate }}<span class="mandatory">*</span></label>
            <div class="input-group">
                <input class="form-control" type="text" name="event_start_date" id="event_start_date" placeholder="mm/dd/yyyy" [(ngModel)]="selectedEventStartDate"
                    (dateSelect)="onDateSelect(); checkSubmitEnabled();"
                    ngbDatepicker #eventStartDate="ngbDatepicker" [minDate]="miniumNgbStartDate"
                    autocomplete="off" [readonly]="isAllFieldsLocked || !isEventStartDateTimeEditable">
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary calendar select-date" type="button" (click)="eventStartDate.toggle();" [disabled]="isAllFieldsLocked || !isEventStartDateTimeEditable"><i class="fa fa-calendar"></i></button>
                </div>
            </div>
        </div>
        <div class="col-md-6">
            <label class="label_grey">{{ 'Admin.event_end_date' | translate }}<span class="mandatory">*</span></label>
            <div class="input-group">
                <input class="form-control" type="text" name="event_end_date" id="event_end_date" placeholder="mm/dd/yyyy" [(ngModel)]="selectedEventEndDate"
                    (dateSelect)="onDateSelect(); checkSubmitEnabled();"
                    ngbDatepicker #eventEndDate="ngbDatepicker" [minDate]="selectedEventStartDate ? selectedEventStartDate: miniumNgbStartDate"
                    autocomplete="off" [readonly]="isAllFieldsLocked || !isEventEndDateTimeEditable">
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary calendar select-date" type="button" (click)="eventEndDate.toggle();" [disabled]="isAllFieldsLocked || !isEventEndDateTimeEditable"><i class="fa fa-calendar"></i></button>
                </div>
            </div>
        </div>
     </div>
     <div *ngIf="!useShiftTimeFlag" class="row pt-2">
        <div class="col-md-6">
            <div class="form-group">
                    <label class="label_grey">{{ 'Admin.event_start_time' | translate }}<span class="mandatory">*</span></label>
                    <input class="form-control" [disabled]="isAllFieldsLocked || useShiftTimeFlag || !isEventStartDateTimeEditable" type="time" name="event_start_time" id="event_start_time" [(ngModel)]="manualUnschedulerEvent.EventStartTime" (input)="checkSubmitEnabled()">
            </div>
        </div>
        <div class="col-md-6">
            <div class="form-group">
                    <label class="label_grey">{{ 'Admin.event_end_time' | translate }}<span class="mandatory">*</span></label>
                    <input class="form-control" [disabled]="isAllFieldsLocked || useShiftTimeFlag || !isEventEndDateTimeEditable" type="time" name="event_end_time" id="event_end_time" [(ngModel)]="manualUnschedulerEvent.EventEndTime" (input)="checkSubmitEnabled()">
            </div>
        </div>
     </div>
     <div *ngIf="useShiftTimeFlag" class="row pt-2">
        <div class="col-md-12">
           <div class="form-group">
              <label class="label_grey">{{ 'Admin.shift_schedule' | translate }}<span class="mandatory">*</span></label>
              <div class="col-lg-12 col-xs-12 col-md-6 col-sm-6">
                  <select [ngClass]="useShiftTimeFlag ? 'black-text' : 'gray-text'" class="form-control" name="line_shift" id="line_shift" tabindex="19" [(ngModel)]="selectedShiftId" (change)="onShiftScheduleChange($any($event.target).value); checkSubmitEnabled()" [disabled]="isAllFieldsLocked || isEventStarted || !useShiftTimeFlag || selectedEventDate == null">
                    <option [value]="0" readonly disabled="true">{{ 'Admin.select_shift_schedule_placeholder' | translate }}</option>
                    <option *ngFor="let item of filteredShiftScheduleListByDayOfWeek" [value]="item.ShiftScheduleId">{{'Admin.shift'| translate}} {{item.ShiftDescription}} - {{item.ShiftStartDate | date : "M/d"}} {{ item.StartTime }}- {{item.ShiftEndDate | date : "M/d"}} {{ item.EndTime }}</option>
                  </select>
              </div>
           </div>
        </div>
     </div>
     <div *ngIf="shiftStartDateTime != null">
        <h5 class="info-text text-center">
            {{ 'Admin.how_unschedule_whole_day_message' | translate }}
        </h5>
        <h5 class="info-text text-center">
            {{shiftStartDateTime | date:'MM/dd/yyyy HH:mm'}} - {{shiftEndDateTime | date:'MM/dd/yyyy HH:mm'}}
        </h5>
     </div>
     <div class="row pt-2">
        <div class="col-md-12">
            <div class="form-group row py-2 justify-content-center">
                <label class="col-5 label_grey">{{ 'Admin.enable_recursion_rule' | translate }}</label>
                <label class="col-3 switch">
                    <input type="checkbox" name="recursion_rule_toggle" id="recursion_rule_toggle" [(ngModel)]="recursionRuleFlag" (change)="onRecursionRuleToggle(); checkSubmitEnabled();" [disabled]="isAllFieldsLocked || isEventStarted">
                    <span class="slider round"></span>
                </label>
            </div>
        </div>
     </div>
     <div class="row pt-2">
        <div class="col-md-12">
            <div *ngIf="useShiftTimeFlag && recursionRuleFlag && showFirstOccurrenceOfWeekdayOption" class="form-group row py-2 justify-content-center">
                    <label class="col-auto label_grey pe-2">{{ 'Admin.first_occurrence_of_weekday_reccurrence' | translate }}</label>
                    <label class="col-3 switch">
                        <input type="checkbox" name="first_monthly_recurrence_mode" id="firstOccurrenceOfWeekday_toggle" [(ngModel)]="manualUnschedulerRecursionRule.FirstOccurrenceOfWeekdayInMonth" (change)="onShiftModeFirstOccurrenceOfWeekdayToggle(); checkSubmitEnabled(); " [disabled]="isAllFieldsLocked || isOriginalEventComplete">
                        <span class=" slider round"></span>
                    </label>
            </div>
        </div>
     </div>
     <div *ngIf="recursionRuleFlag" class="row pt-2">
        <div class="col-md-6">
           <div class="form-group">
              <label class="label_grey">{{ 'Admin.recurrence_type' | translate }}<span class="mandatory">*</span></label>
              <div class="col-lg-12 col-xs-12 col-md-6 col-sm-6">
                  <select class="form-control" name="recurrence_type" id="recurrence_type" [disabled]="isAllFieldsLocked || (useShiftTimeFlag && selectedShiftId != 0) || isOriginalEventComplete" tabindex="19" [(ngModel)]="selectedRecurrenceType" (change)="onRecurrenceTypeChange($any($event.target).value); checkSubmitEnabled()">
                    <option [value]="0" readonly disabled="true">{{ 'Admin.select_recurrence_type_placeholder' | translate }}</option> 
                    <option *ngFor="let item of recurrenceTypeList" [value]="item.id">{{ item.text }}</option>
                  </select>
              </div>
           </div>
        </div>
        <div class="col-md-6">
            <label class="label_grey">{{ 'Admin.recursion_rule_end_date' | translate }}<span class="mandatory">*</span></label>
            <div class="input-group">
                <input class="form-control" type="text" name="recursion_rule_end_date" id="recursion_rule_end_date" placeholder="mm/dd/yyyy" [(ngModel)]="selectedRecursionRuleEndDate" (dateSelect)="checkSubmitEnabled()" ngbDatepicker #recursionRuleEndDate="ngbDatepicker" [minDate]="miniumNgbStartDate" autocomplete="off" [readonly]="isAllFieldsLocked || !isRecursionRuleEndDateEditable">
                <div class="input-group-append">
                    <button class="btn btn-outline-secondary calendar select-date" type="button" (click)="recursionRuleEndDate.toggle();" [disabled]="isAllFieldsLocked || !isRecursionRuleEndDateEditable"><i class="fa fa-calendar"></i></button>
                </div>
            </div>
        </div>
     </div>
     <div *ngIf="!useShiftTimeFlag && recursionRuleFlag && this.manualUnschedulerRecursionRule.RecurrenceType=='MONTHLY'"  class="row pt-2">
        <div *ngIf="showFirstOccurrenceOfWeekdayOption" class="form-group col-12">
                <label class="col-auto label_grey pe-2">{{ 'Admin.first_occurrence_of_weekday_reccurrence' | translate }}</label>
                <label class="col switch">
                    <input type="checkbox" name="first_monthly_recurrence_mode" id="firstOccurrenceOfWeekday_toggle" [(ngModel)]="manualUnschedulerRecursionRule.FirstOccurrenceOfWeekdayInMonth" (change)="onFirstWeekdayReccurrenceChange(0); checkSubmitEnabled(); " [disabled]="isAllFieldsLocked || isEventStarted">
                    <span class=" slider round"></span>
                </label>
        </div>
        <div *ngIf="showFirstWeekdayOfMonthOption" class="form-group col-12 pt-2">
                <label class="col-auto label_grey pe-2">{{ 'Admin.first_weekday_of_month_reccurrence' | translate }}</label>
                <label class="col switch">
                    <input type="checkbox" name="first_monthly_recurrence_mode" id="firstWeekdayOfMonth_toggle" [(ngModel)]="manualUnschedulerRecursionRule.FirstWeekdayOfMonth" (change)="onFirstWeekdayReccurrenceChange(1); checkSubmitEnabled(); " [disabled]="isAllFieldsLocked || isEventStarted">
                    <span class=" slider round"></span>
                </label>
        </div>
     </div>
     <div *ngIf="recursionRuleFlag && !hideDaysOfWeekSelectFlag" class="row pt-2">
        <div class="col-md-12">
            <div class="form-group">
              <label class="label_grey">{{ 'Admin.days_of_week' | translate }}<span class="mandatory">*</span></label>
              <!-- [style.pointer-events] attribute prevents the dropdown from expanding and showing the days when the 'Days of Week' field is disabled -->
              <div class="col-lg-12 col-xs-12 col-md-6 col-sm-6" [style.pointer-events]="(isAllFieldsLocked || (useShiftTimeFlag && selectedShiftId != 0) || isOriginalEventComplete) ? 'none' : null">
                  <ng-multiselect-dropdown  
                  [settings]="multiSelectDropDownSettings" 
                  [data]="daysOfWeekList" 
                  (onSelect)="onDaySelect($event)" 
                  (onDeSelect)="onDayDeSelect($event)" 
                  [(ngModel)]="selectedDaysOfWeekList" 
                  [ngModelOptions]="{ standalone: true }"
                  [disabled]="isAllFieldsLocked || (useShiftTimeFlag && selectedShiftId != 0) || isOriginalEventComplete"
                  ></ng-multiselect-dropdown>
              </div>
              <h5 *ngIf="this.manualUnschedulerRecursionRule.RecurrenceType === this.recurrenceTypes.Weekly" class="info-text">
                    {{ 'Admin.recursion_type_weekly_info' | translate }}
              </h5>
           </div>
        </div>
     </div>
     <div *ngIf="recursionRuleFlag" class="row pt-2">
        <div class="col-md-12">
            <div *ngIf="manualUnschedulerRecursionRule.RecurrenceType === this.recurrenceTypes.Daily || manualUnschedulerRecursionRule.RecurrenceType === ''" class="form-group">
              <label class="label_grey">{{ 'Admin.recursion_rule_interval' | translate }}<span class="mandatory">*</span></label>
              <div class="col-lg-12 col-xs-12 col-md-6 col-sm-6">
                  <select class="form-control" name="recursionRuleInterval" id="recursionRuleInterval" tabindex="19" [(ngModel)]="manualUnschedulerRecursionRule.RecurrenceInterval" (change)="checkSubmitEnabled()" [disabled]="isAllFieldsLocked || isOriginalEventComplete">
                    <option [value]="0" readonly disabled="true">{{ 'Admin.select_recursion_rule_interval_placeholder' | translate }}</option> 
                    <option *ngFor="let item of recurrenceDailyIntervalList" [value]="item.id">{{ item.text }}</option>
                  </select>
              </div>
           </div>
           <div *ngIf="manualUnschedulerRecursionRule.RecurrenceType === this.recurrenceTypes.Weekly" class="form-group">
              <label class="label_grey">{{ 'Admin.recursion_rule_interval' | translate }}<span class="mandatory">*</span></label>
              <div class="col-lg-12 col-xs-12 col-md-6 col-sm-6">
                  <select class="form-control" name="recursionRuleInterval" id="recursionRuleInterval" tabindex="19" [(ngModel)]="manualUnschedulerRecursionRule.RecurrenceInterval" (change)="checkSubmitEnabled()" [disabled]="isAllFieldsLocked || isOriginalEventComplete">
                    <option [value]="0" readonly disabled="true">{{ 'Admin.select_recursion_rule_interval_placeholder' | translate }}</option> 
                    <option *ngFor="let item of recurrenceWeeklyIntervalList" [value]="item.id">{{ item.text }}</option>
                  </select>
              </div>
           </div>
           <div *ngIf="manualUnschedulerRecursionRule.RecurrenceType === this.recurrenceTypes.Monthly" class="form-group">
              <label class="label_grey">{{ 'Admin.recursion_rule_interval' | translate }}<span class="mandatory">*</span></label>
              <div class="col-lg-12 col-xs-12 col-md-6 col-sm-6">
                  <select class="form-control" name="recursionRuleInterval" id="recursionRuleInterval" tabindex="19" [(ngModel)]="manualUnschedulerRecursionRule.RecurrenceInterval" (change)="checkSubmitEnabled()" [disabled]="isAllFieldsLocked || isOriginalEventComplete">
                    <option [value]="0" readonly disabled="true">{{ 'Admin.select_recursion_rule_interval_placeholder' | translate }}</option> 
                    <option *ngFor="let item of recurrenceMonthlyIntervalList" [value]="item.id">{{ item.text }}</option>
                  </select>
              </div>
           </div>
        </div>
     </div>
     <div class="row pt-3">
        <div class="col-md-6 text-left">
            <button 
                class="btn btn-secondary"
                [disabled]="isAllFieldsLocked || !isDeleteEnabled"
                [class.btn-enabled]="isDeleteEnabled"
                [class.btn-grey]="!isDeleteEnabled"
                name="delete" 
                id="delete"
                (click)="onDelete()">
                Delete
            </button>
        </div>
        <div class="col-md-6 text-right">
            <button 
                class="btn btn-secondary"
                [disabled]="isAllFieldsLocked || !isSubmitEnabled"
                [class.btn-enabled]="isSubmitEnabled"
                [class.btn-grey]="!isSubmitEnabled"
                name="submit" 
                id="submit"
                (click)="onSubmit()">
                Submit
            </button>
        </div>
        <div class="pt-3">
            <div *ngFor="let error of formSubmitRequirementMessages" class="col-lg-12 text-left">
                <h5 class="error-list">
                    {{ error }}
                </h5>
            </div>
        </div>
    </div>
    <div *ngIf="recursionRuleFlag && manualUnschedulerRecursionRule.RecursionRuleExceptionDates.length" class="row px-2">
        <label class="label_grey mx-0 ps-0">{{ 'Admin.recursion_exception_dates' | translate }}</label>
        <div class="col-12 recursion-date-cont mt-1">
            <div class="row recursion-date-item" *ngFor="let date of manualUnschedulerRecursionRule.RecursionRuleExceptionDates" (click)="onRecursionExceptionSelect(date)">
                <div class="col-12 py-1 ">
                    <span>{{date| date:'MM/dd/yyyy'}}</span>
                </div>
            </div>
        </div>
    </div>
</div>
</ng-template>

